<script setup>
const props = defineProps([
	"to",
	"hash",
	"href",
	"disabled",
	"processing",
	"iconLeft",
	"icon",
	"iconRight",
	"target",
]);
</script>

<template>
	<router-link
		v-if="to"
		class="button group"
		:class="{ 'cursor-not-allowed': disabled }"
		:disabled
		:to
	>
		<slot />
	</router-link>
	<component
		v-else
		:is="href ? 'a' : 'button'"
		class="button group"
		:class="{ 'cursor-not-allowed': disabled }"
		:disabled="disabled"
		:target="href ? (target ?? '_blank') : null"
		:href
	>
		<div class="relative isolate flex h-9 flex-col overflow-hidden lg:h-11">
			<span
				class="leading-[0.8] transition-transform duration-400"
				:class="{ 'group-hover:-translate-y-full': !disabled }"
			>
				<slot />
			</span>
			<span
				class="leading-[0.8] transition-transform duration-400"
				:class="{ 'group-hover:-translate-y-full': !disabled }"
				aria-hidden="true"
			>
				<slot />
			</span>
		</div>
	</component>
</template>
